
import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { NavigateNext } from '@mui/icons-material';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';

const DynamicBreadcrumbs = () => {
  const location = useLocation();
  const breadcrumbs = useBreadcrumbs();

  // Don't render breadcrumbs on the dashboard or if there's only one crumb
  if (location.pathname === '/dashboard' || breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ py: 2 }}>
      <Breadcrumbs
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return isLast ? (
            // The last crumb is the current page, so it's just text
            <Typography key={crumb.path} color="text.primary" fontWeight={500}>
              {crumb.label}
            </Typography>
          ) : (
            // Previous crumbs are clickable links using React Router's Link
            <Link
              key={crumb.path}
              component={RouterLink}
              to={crumb.path}
              underline="hover"
              color="inherit"
            >
              {crumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default DynamicBreadcrumbs;
// // ====================================
// // src/components/common/Breadcrumbs/DynamicBreadcrumbs.jsx
// // ====================================
// import React from 'react';
// import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { NavigateNext } from '@mui/icons-material';
// import { useNavigation } from '../../../hooks/useNavigation';

// const DynamicBreadcrumbs = () => {
//   const navigate = useNavigate();
//   const { breadcrumbs, canAccess } = useNavigation();

//   const handleClick = (path) => {
//     if (canAccess(path)) {
//       navigate(path);
//     }
//   };

//   if (breadcrumbs.length <= 1) return null;

//   return (
//     <Box sx={{ py: 2 }}>
//       <Breadcrumbs
//         separator={<NavigateNext fontSize="small" />}
//         aria-label="breadcrumb"
//       >
//         {breadcrumbs.map((crumb, index) => {
//           const isLast = index === breadcrumbs.length - 1;
//           const hasAccess = canAccess(crumb.path);

//           if (isLast) {
//             return (
//               <Typography key={crumb.path} color="text.primary" fontWeight={500}>
//                 {crumb.label}
//               </Typography>
//             );
//           }

//           return (
//             <Link
//               key={crumb.path}
//               underline="hover"
//               color="inherit"
//               onClick={() => handleClick(crumb.path)}
//               sx={{ 
//                 cursor: hasAccess ? 'pointer' : 'default',
//                 opacity: hasAccess ? 1 : 0.5,
//               }}
//             >
//               {crumb.label}
//             </Link>
//           );
//         })}
//       </Breadcrumbs>
//     </Box>
//   );
// };

// export default DynamicBreadcrumbs;
